export default "__VITE_ASSET__D0bw84G1__"